<template>
  <div>
    <b-card :title="title">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="mr-1 per-page-selector d-inline-block ml-50"
            />
            <b-button v-b-modal.assign-param variant="primary">
              Assign Parameter
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
            class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
          >
            <label class="mr-1">
              Search
            </label>
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                class="mr-1 d-inline-block"
                placeholder="Search..."
                v-model="searchWord"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        class="border"
        no-local-sorting
        @sort-changed="sortingChanged"
        responsive
        striped
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="param"
        :fields="paramFields"
      >
        <template #cell(action)="productItem">
          <div class="d-flex justify-content-between">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="mr-1 btn-icon"
              @click="showMsgBoxDelete(productItem.item.id_cat_map)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Showing {{ pagination.from }} to {{ pagination.to }} of
              {{ pagination.total }} entries
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="pagination.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="changePage"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      title="Assign New Parameter"
      hide-footer
      id="assign-param"
      centered
      hide-header-close
    >
      <b-form @submit.prevent="addParam">
        <b-form-group label-for="product">
          <template slot="label">
            <span>Group <strong class="text-danger">*</strong></span>
          </template>
          <v-select
            v-model="selectedGroup"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            key="cat_comp_id"
            label="compare_category"
            :options="groupParam"
            @input="fetchAllParam()"
          />
        </b-form-group>
        <b-form-group label-for="product">
          <template slot="label">
            <span>Parameter <strong class="text-danger">*</strong></span>
          </template>
          <v-select
            v-model="selectedParam"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            key="id_cat_comp"
            label="param_name"
            :options="allparam"
          />
        </b-form-group>
        <b-form-group label-for="value">
          <template slot="label">
            <span>Value <strong class="text-danger">*</strong></span>
          </template>
          <b-form-input id="title" required v-model="param_value" />
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="light"
            class="mr-1"
            @click="$bvModal.hide('assign-param')"
            :disabled="form.isLoading"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="form.isLoading">
            Save
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BRow,
  BCard,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
  BForm,
  BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ParticipantPccTable from '@/views/admin/pcc/ParticipantPCCTable'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BCard,
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    VSelect,
    BFormInput,
    BPagination,
    BModal,
    ParticipantPccTable,
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      title: '',
      param_value: '',
      sortBy: 'start_datetime',
      sortDesc: true,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      param: [],
      allparam: [],
      groupParam: [],
      paramFields: [
        {
          key: 'param.param_name',
          label: 'Parameter'
        },
        {
          key: 'nilai',
          formatter: (val, key, item) => {
            return val ? val.replace(/(<([^>]+)>)/gi, "") : ''
          },
          label: 'Value'
        },
        'action',
      ],
      selectedGroup: null,
      selectedParam: [],
      searchWord: '',
      form: { isLoading: false },
    }
  },

  watch: {
    perPage() {
      this.fetchParam()
    },
    currentPage() {
      this.fetchParam()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
  },

  created() {
    this.$http.get('/product/id/'+this.$route.params.key+'/set/first').then(response => { 
      this.title = response.data.data.records.PRODUCT
    })
  },

  mounted() {
    this.fetchParam()
    this.fetchAllParam()
    this.fetchParamGroup()
  },

  methods: {
    fetchParam() {
      this.isBusy = true

      this.$http
        .get('/compare-product/param', {
          params: {
            id: this.$route.params.key,
            page: this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim(),
            sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.param = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    fetchParamGroup() {
      this.$http
        .get(`/compare-product/category`)
        .then(res => {
          this.groupParam = res.data.data
      })
    },
    fetchAllParam() {
      console.log(this.selectedGroup)
      this.$http
        .get(`/compare-product/all-param?`,{
          params: {
            group: this.selectedGroup ? this.selectedGroup.cat_comp_id : null,
          },
        })
        .then(res => {
          this.allparam = res.data.data
      })
    },

    searchByTitle: debounce(function() {
      this.fetchParam()
      this.fetchAllParam()
    }, 200),

    addParam() {
      console.log(this.selectedParam)
      this.form.isLoading = true

      this.$http
        .post('/compare-product/param', {
          param: this.selectedParam.id_comp_param,
          produk: this.$route.params.key,
          value: this.param_value
        })
        .then(() => {
          this.$notif(
            'Success',
            'Param successfully assigned.',
            'success'
          )
          this.$bvModal.hide('assign-param')
          this.selectedParam = []
          this.selectedGroup = null
          this.param_value = null
          this.fetchParam()
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => (this.form.isLoading = false))
    },

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchParam()
      this.fetchAllParam()
    },

    deleteCompare(id) {
      return this.$http.delete(`compare-product/del-param/${id}`)
    },

    showMsgBoxDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteCompare(id)
              .then(() => {
                this.$notif(
                  'Success',
                  'PCC has been successfully deleted.',
                  'success'
                )
                this.fetchParam()
                this.fetchAllParam()
              })
              .catch(err => {
                this.$notif('Error', `${err.message}`, 'error')
              })
          }
        })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
